import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { Box } from '@chakra-ui/react';
import { zodResolver } from '@hookform/resolvers/zod';

import Button from 'components/_core/Button';
import * as Form from 'components/_core/form';

import { CompanyNameProps } from '../..';
import companyNameSchema, {
  CompanyNameSchema,
} from '../../libs/companyNameSchema';
import locales from '../../locales';

type CompanyNameFormProps = {
  formData: CompanyNameSchema;
} & Pick<CompanyNameProps, 'onSubmit' | 'isSending'>;

const CompanyNameForm: FC<CompanyNameFormProps> = ({
  formData,
  isSending,
  onSubmit,
}) => {
  const {
    formState: { errors },
    handleSubmit,
    register,
  } = useForm<CompanyNameSchema>({
    defaultValues: formData,
    mode: 'onBlur',
    resolver: zodResolver(companyNameSchema),
  });

  const submitHandler = handleSubmit((values) => {
    // handleSubmit is called only if form validation is successful
    onSubmit(values);
  });

  return (
    <Box as="form" onSubmit={submitHandler}>
      <Form.Field
        error={errors.legalName?.message}
        label={locales.legalNameLabel}
        marginBottom="space-32"
      >
        <Form.Input {...register('legalName')} />
      </Form.Field>

      <Button isExpanded isLoading={isSending} type="submit">
        {locales.ctaSave}
      </Button>
    </Box>
  );
};

export default CompanyNameForm;
